// For legacy block support
// import 'slick-carousel';
// import initFeatherlight from 'featherlight'
// initFeatherlight();
import './legacy-blocks';

import './blog';
import './navigation';
import './responsive-spacers';
import './search';
import './fslightbox-3.6.0';
import htmx from 'htmx.org';
import Splide from '@splidejs/splide';
import Player from '@vimeo/player';

htmx.config.globalViewTransitions = true;

const b121ImageCarousel = document.querySelector('.splide.b121-image-carousel');
if (b121ImageCarousel) {
  new Splide(b121ImageCarousel, {
      type: 'loop',
      rewind: true,
      height: '455px',
      autoWidth: true,
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 5000,
      focus: 'center',
  }).mount();
}

// Vimeo Autoplay stuff
window.vimeoPlayers = {};

function manageAutoplay(key) {
    let source = fsLightboxInstances[key].elements.sources[0];

    if (source.classList.contains('vimeo-autoplay')) {
        let frame = source.querySelector('iframe');
        if (!(key in vimeoPlayers)) {
            vimeoPlayers[key] = new Player(frame);
        }
        frame.addEventListener('load', () => vimeoPlayers[key].play())
    }
}
window.addEventListener('load', function () {
    // fsLightbox.props.onOpen = manageAutoplay;
    console.log(fsLightboxInstances);
    Object.keys(fsLightboxInstances).forEach((key) => {
        fsLightboxInstances[key].props.onOpen = manageAutoplay.bind(null, key);
    });
})

document.addEventListener('DOMContentLoaded', function () {
        // Our Team Block
        const modalOverlay = document.querySelector('#ibb-bios-modal-overlay');
        const modalTriggers = document.querySelectorAll('.ibb-bios-bio-modal-trigger');
        const modalCloseBtns = document.querySelectorAll('.ibb-bios-modal-close');
        let currentOpen = null;
    
        function closeModal(modal) {
            modalOverlay?.classList.remove('show');
            modal.classList.add('hide');
    
            setTimeout(() => {
                // modalOverlay?.classList.remove('show','hide');
                modal.classList.remove('show','hide');
                currentOpen = null;
            }, 500);
        }
        
    
        modalTriggers.forEach((el) => {
            el.addEventListener('click', (e) => {
                modalOverlay?.classList.add('show');
                el.nextElementSibling?.classList.add('show');
                currentOpen = el.nextElementSibling;
            })
        });
        modalCloseBtns.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                let toClose = el.closest('.ibb-bios-modal');
                closeModal(toClose);
            })
        });
        document.addEventListener('click', (e) => {
            if (currentOpen && e.target === modalOverlay) {
                closeModal(currentOpen);
            }
        });
    
});


function adjustVideoLoopHeight() {
    const hero = document.getElementById('hero');
    const videoLoop = document.getElementById('video-loop');
    const video = videoLoop ? videoLoop.querySelector('video') : null;

    if (window.innerWidth >= 1024 && window.innerWidth <= 1470 && hero && videoLoop && video) {
        const newHeight = hero.offsetHeight + 'px';
        videoLoop.style.height = newHeight;
        video.style.height = newHeight;
        video.style.width = '100%';
        video.style.objectFit = 'cover';
    } else if (videoLoop && video) {
        videoLoop.style.height = '';
        video.style.height = '';
        video.style.width = '';
        video.style.objectFit = '';
    }
}

// Run on page load
document.addEventListener('DOMContentLoaded', adjustVideoLoopHeight);

// Run on window resize
window.addEventListener('resize', adjustVideoLoopHeight); 